import { BaseChartAPIProps } from '~/types/create.types';

import { reDraw } from '../create/recalculate/recalculate';

export const onMouseLeave = (_: MouseEvent, base: BaseChartAPIProps) => {
  reDraw(base);
};
